export const ALL_USER_PERM = ["SuperAdmin", "Admin", "User", "CEO", "Dy_CEO", "Asst_CEO", "Div_Head", "Group_Head", "ISO_Facilitator", "MR", "Auditor", "QA_Head", "QA_User"]
// export const ONLY_CISF_PERM = ["CISF"]
// export const ONLY_ADMIN_PERM = ["Admin"]
// export const ONLY_VISITOR_PERM = ["Visitor"]
// export const EXCEPT_VISITOR_PERM_PERM = ["SuperAdmin", "Admin", "CISF"]
// export const EXCEPT_VISITOR_ADMIN_PERM_PERM = ["SuperAdmin", "CISF"]
// export const EXCEPT_VISITOR_CISF_PERM_PERM = ["SuperAdmin", "Admin"]
